const config = {
    /*Environment :'http://10.129.91.15',
    Port:'80',*/

    Environment: 'http://10.21.53.124',
    Port: '8080',
};

export default config;
